var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { InfoModalComponent } from "../../views/modal/info_modal.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "../../translate/translate.service";
var BuyingChartDetail = /** @class */ (function (_super) {
    __extends(BuyingChartDetail, _super);
    function BuyingChartDetail(activeModal, translate) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.translate = translate;
        _this.isLoad = false;
        _this.status = 'Active';
        _this.stats = [];
        return _this;
    }
    BuyingChartDetail.prototype.f1 = function (item) {
        console.log('f1', item, this.status);
        return item;
    };
    BuyingChartDetail.prototype.ok = function () {
        this.close();
    };
    return BuyingChartDetail;
}(InfoModalComponent));
export { BuyingChartDetail };
